export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-safety-cone-043625ada700ff8372f0614376dabc36.svg";